import { render } from "./TitledText.vue?vue&type=template&id=228e212f&scoped=true"
import script from "./TitledText.vue?vue&type=script&lang=js"
export * from "./TitledText.vue?vue&type=script&lang=js"

import "./TitledText.vue?vue&type=style&index=0&id=228e212f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-228e212f"

export default script